import { API, isEmbedded } from "@/lib/api";

const rid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

function getIds() {
  let vid = localStorage.getItem("co_vid");
  if (!vid) { vid = rid(); localStorage.setItem("co_vid", vid); }
  let sid = sessionStorage.getItem("co_sid");
  const first = !sid;
  if (!sid) { sid = rid(); sessionStorage.setItem("co_sid", sid); }
  return { vid, sid, first };
}

export function track(event, path) {
  try {
    const { vid, sid, first } = getIds();
    const p = new URLSearchParams(window.location.search);
    const body = {
      event, path, visitor_id: vid, session_id: sid, embedded: isEmbedded(),
      referrer: first ? document.referrer || null : null,
      utm_source: p.get("utm_source"), utm_medium: p.get("utm_medium"), utm_campaign: p.get("utm_campaign"),
    };
    fetch(`${API}/analytics/track`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body), keepalive: true, credentials: "include",
    }).catch(() => {});
  } catch {
    // analytics must never break the app
  }
}
